import React from 'react'
import FooterComponent from '../components/footer.component'
import ArtistAboutComponent from '../components/artistAbout.component'
import img from '../images/Adila.jpg'
import useSEO from '../hooks/useSEO'

function AboutArtist() {
    useSEO({
        title: 'Meet Our Artist | Mehandi Malabar – Expert Henna Artist in Malappuram',
        description: 'Learn about the skilled mehandi artist behind Mehandi Malabar, Kondotty. Years of experience crafting bridal, Arabic and traditional henna designs across Kerala.',
        path: '/about',
    });

    return (
        <div>
            <ArtistAboutComponent />
            <div className='art-40-d-flex'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 art-col-flex'>
                            <img
                                src={img}
                                style={{ width: 'auto', maxHeight: '600px', borderRadius: '20px' }}
                                alt="Mehandi Malabar artist applying intricate henna designs"
                            />
                        </div>
                        <div className='col-md-6'>
                            <br />
                            <h2>MEHANDI MALABAR</h2>
                            <p>Mehandi, often referred to as henna, is a time-honored art form that has transcended generations and cultures. This exquisite tradition involves the application of intricate and ornate designs on the skin, primarily on the hands and feet, using a paste made from the leaves of the henna plant. Beyond its aesthetic appeal, Mehandi carries deep cultural significance, symbolizing joy, celebration, and the sacred bond of love, particularly in South Asian and Middle Eastern cultures.</p>
                            <p>The process of adorning oneself with Mehandi is not merely an act of beautification; it is a cherished ritual that accompanies significant life events, such as weddings, festivals, and other special occasions. As a Mehandi artist, I am dedicated to preserving this ancient art form and creating bespoke designs that blend tradition with contemporary aesthetics, allowing individuals to express their unique stories and emotions through the language of henna. My passion lies in turning hands and feet into canvases of art, each stroke celebrating the beauty of cultural heritage and personal expression.</p>
                        </div>
                    </div>
                </div>
            </div>
            <FooterComponent />
        </div>
    )
}

export default AboutArtist
